import {Component} from 'react'
import GradientDirectionItem from '../GradientDirectionItem'
import {
  AppContainer,
  Heading,
  DirectionList,
  ColorsContainer,
  ColorContainer,
  ColorInput,
  ColorValue,
  GenerateButton,
} from './styledComponents'

const gradientDirectionsList = [
  {directionId: 'TOP', value: 'top', displayText: 'Top'},
  {directionId: 'BOTTOM', value: 'bottom', displayText: 'Bottom'},
  {directionId: 'RIGHT', value: 'right', displayText: 'Right'},
  {directionId: 'LEFT', value: 'left', displayText: 'Left'},
]

class GradientGenerator extends Component {
  state = {
    activeDirection: gradientDirectionsList[0].value,
    firstColor: '#8ae323',
    secondColor: '#014f7b',
    gradientValue: {
      direction: gradientDirectionsList[0].value,
      color1: '#8ae323',
      color2: '#014f7b',
    },
  }

  setActiveDirection = value => {
    this.setState({activeDirection: value})
  }

  onChangeFirstColor = event => {
    this.setState({firstColor: event.target.value})
  }

  onChangeSecondColor = event => {
    this.setState({secondColor: event.target.value})
  }

  onClickGenerate = () => {
    const {activeDirection, firstColor, secondColor} = this.state
    this.setState({
      gradientValue: {
        direction: activeDirection,
        color1: firstColor,
        color2: secondColor,
      },
    })
  }

  render() {
    const {activeDirection, firstColor, secondColor, gradientValue} = this.state

    return (
      <AppContainer
        data-testid="gradientGenerator"
        direction={gradientValue.direction}
        color1={gradientValue.color1}
        color2={gradientValue.color2}
      >
        <Heading>Generate a CSS Color Gradient</Heading>

        <p>Choose Direction</p>
        <DirectionList>
          {gradientDirectionsList.map(each => (
            <GradientDirectionItem
              key={each.directionId}
              details={each}
              isActive={activeDirection === each.value}
              setActiveDirection={this.setActiveDirection}
            />
          ))}
        </DirectionList>

        <p>Pick the Colors</p>
        <ColorsContainer>
          <ColorContainer>
            <ColorValue>{firstColor}</ColorValue>
            <ColorInput
              type="color"
              value={firstColor}
              onChange={this.onChangeFirstColor}
            />
          </ColorContainer>

          <ColorContainer>
            <ColorValue>{secondColor}</ColorValue>
            <ColorInput
              type="color"
              value={secondColor}
              onChange={this.onChangeSecondColor}
            />
          </ColorContainer>
        </ColorsContainer>

        <GenerateButton type="button" onClick={this.onClickGenerate}>
          Generate
        </GenerateButton>
      </AppContainer>
    )
  }
}

export default GradientGenerator
